import React from 'react';
import styled from 'styled-components';
import { getTranslatedString } from 'helpers/i18n';
import Col from 'components/ui/Col';
import Form from 'components/ui/Form';
import Spacer from 'components/ui/Spacer';
import Row from 'components/ui/Row';
import PropertyMultiselectAdvanced from 'components/shared/PropertyMultiselectAdvanced';

const StyledTitle = styled.span`
  font-size: 18px;
  font-family: 'Circular-Bold';
`;

const StyledColMb8 = styled(Col)`
  margin-bottom: 8px;
`;

const PropertyInput = ({ values, errors, touched, setFieldValue }) => {
  const handleChange = properties => {
    setFieldValue('properties', properties);
  };

  return (
    <Spacer mb={1}>
      <Row gutter={16}>
        <StyledColMb8 span={24}>
          <StyledTitle>
            {getTranslatedString('landlordPortal.promotions.whichProperties')}
          </StyledTitle>
        </StyledColMb8>
        <Col span={24}>
          <Form.Item label={getTranslatedString('landlordPortal.promotions.propertiesLabel')}>
            <PropertyMultiselectAdvanced
              name="properties"
              onChange={handleChange}
              value={values.properties}
              error={touched.properties && errors.properties}
            />
          </Form.Item>
        </Col>
      </Row>
    </Spacer>
  );
};

export default PropertyInput;
